/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceTypeToSecurityGroup } from '../models/ResourceTypeToSecurityGroup';
import { SubnetPerAvailabilityZone } from '../models/SubnetPerAvailabilityZone';

export class AwsVpcConnectivityConfig {
  /**
  * VPC region.
  */
  'region': string;
  /**
  * VPC ID.
  */
  'vpc': string;
  /**
  * Subnets to configure for availability zones in the VPC. For availability zones not specified in this list, Eon attempts to use the default subnet. 
  */
  'subnetsPerAvailabilityZone'?: Array<SubnetPerAvailabilityZone>;
  'securityGroups'?: ResourceTypeToSecurityGroup;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "vpc",
      "baseName": "vpc",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetsPerAvailabilityZone",
      "baseName": "subnetsPerAvailabilityZone",
      "type": "Array<SubnetPerAvailabilityZone>",
      "format": ""
    },
    {
      "name": "securityGroups",
      "baseName": "securityGroups",
      "type": "ResourceTypeToSecurityGroup",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsVpcConnectivityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

